import { Button, Typography } from 'antd';
import styled from 'styled-components';

export const HiddenPriceContainerStyled = styled.div`
	gap: 8px;
	display: flex;
	align-items: center;
`;

export const PriceStyled = styled.p`
	overflow: hidden;
	margin: 0;
	white-space: nowrap;
	letter-spacing: 0.36px;
	font-weight: 600;
	font-size: 24px;
	line-height: 28px;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 30px;
	}
`;

export const ButtonStyled = styled(Button)`
	padding: 0;
	@media (min-width: ${props => props.theme.breakpoints.xs}) {
		font-size: 14px;
	}
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 16px;
	}
`;

export const PeriodStyled = styled(Typography.Text)`
	overflow: hidden;
	margin-top: 12px;
	margin-bottom: 6px;
	color: #8c8c8c;
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		font-size: 16px;
	}
`;
